import { Navigate, Route, Routes } from 'react-router-dom'

import Layout from './components/Layout'
import RequireAuth from './components/RequireAuth'
import Browse from './pages/Browse'
import Dashboard from './pages/Dashboard'
import LanguageDetail from './pages/LanguageDetail'
import Login from './pages/Login'
import Practice from './pages/Practice'
import Register from './pages/Register'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route
          index
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="browse" element={<Browse />} />

        {/* Readable by anyone for a published language; the page itself hides
            the editing controls when the viewer is not the owner. */}
        <Route path="languages/:id" element={<LanguageDetail />} />
        <Route
          path="languages/:id/practice"
          element={
            <RequireAuth>
              <Practice />
            </RequireAuth>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
